let USDollar = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

export function formatPrice(price: number): string {
  // Safety check: ensure price is a valid number
  if (!isFinite(price) || isNaN(price)) {
    return "$0.00";
  }
  return USDollar.format(price);
}
